module.exports = __webpack_public_path__ + "static/img/page-logo.5abee6e8.png";